export interface TeamRole {
  name: string
  description: string
  bullets?: string[]
}

export interface TeamCard {
  number?: number
  title: string
  intro?: string
  paragraphs?: string[]
  roles?: TeamRole[]
}

export const teamCards: TeamCard[] = [
  {
    number: 1,
    title: 'Global Lead & Working Team',
    intro: 'This group will do the heavy lifting and should include:',
    roles: [
      {
        name: 'Global Brand Lead',
        description:
          'Owns the overall process and is ultimately responsible for its success. He/She is  supported by the extended category/ brand teams (Insight, XP/ Creative, Design& Packaging, GDI, …). The collaborations for example happens with:',
        bullets: [
          'XP/Creative and design teams especially for the Brand stream and overall Meaningful Brand Role',
          'Overall category mktg teams & R&D teams, on the Product workstream',
          'Insight team when Human tension is defined',
          'WPP/Lead agency Creative Strategy is continuously engaged to provide input and push the work across all workstreams.',
        ],
      },
      {
        name: 'PMO or Facilitator',
        description: 'Supports with orchestration and logistics.',
      },
    ],
  },
  {
    number: 2,
    title: 'Feedback Givers',
    paragraphs: [
      'This group provides input during the process and before it goes out for approvals.',
      'Throughout the process, OU CMOs provide feedback (directly or delegating their OU categ teams) but are not actively performing any of the work. However, ultimately, they should be aligned with the output.',
      'It is highly suggested to engage with 1-3 appointed "OU Categ/ Brand Champions" throughout the process from OUs with important EP Combos for your brand.',
    ],
  },
  {
    number: 3,
    title: 'Approvers',
    paragraphs: [
      'Use two layers before global release and scaling.',
      'Throughout the process, OU CMOs provide feedback (directly or delegating their OU categ teams) but are not actively performing any of the work. However, ultimately, they should be aligned with the output.',
      'It is highly suggested to engage with 1-3 appointed "OU Categ/ Brand Champions" throughout the process from OUs with important EP Combos for your brand.',
    ],
    roles: [
      {
        name: 'Global GCP',
        description:
          'Sponsor of the entire process and must approve the outcome before it goes to the Chief Marketing and Customer Commercial Officer for final signoff.',
      },
      {
        name: 'OU MD or OU Marketing Lead',
        description: 'Gives the final approval before global release.',
      },
    ],
  },
]

export const necessaryRolesColumns: string[][] = [
  ['Global CMO', 'Global Category President'],
  ['OU CMOs', 'Global Brand Lead', 'Global XP Lead rep'],
  ['Design & Pckg rep', 'Global Insights rep', 'Global Category Strategy'],
  ['R&D (TCR & GDI)', 'WPP Strategist'],
]

export const teamFootnote =
  'This is for Global Brands. For OU/Local Brands, OU teams lead with OU MD/Marketing Lead sign-off and Global Category consulted.'

export type RapidLetter = 'R' | 'A' | 'P' | 'I' | 'D'

export interface RapidRow {
  letter: RapidLetter
  label: string
  color: string
}

export const rapidRows: RapidRow[] = [
  { letter: 'R', label: 'RECOMMENDS', color: '#eea49e' },
  { letter: 'A', label: 'AGREES', color: '#fadb83' },
  { letter: 'P', label: 'PERFORMS', color: '#7bca9f' },
  { letter: 'I', label: 'INPUT', color: '#a3c4fa' },
  { letter: 'D', label: 'DECIDES', color: '#d6a4de' },
]

export interface RapidDefinition {
  prefix?: string
  bold: string
  rest: string
}

export const rapidDefinitions: RapidDefinition[] = [
  {
    bold: 'Recommends',
    rest: ' a solution to the decision maker, after considering all inputs and judgements. 20% of the work happens here (overseeing and leading the process).',
  },
  {
    bold: 'Agrees',
    rest: ' with the recommendation and must be consulted to ensure its feasibility.',
  },
  {
    bold: 'Performs',
    rest: ' and is responsible for successfully executing the decision. 80% of the work happens here.',
  },
  {
    prefix: 'Proactively provides expert ',
    bold: 'input',
    rest: ' that helps develop the recommendation, but their agreement is not required.',
  },
  {
    bold: 'Decides',
    rest: ' whether to sign off on the recommendation. Is responsible for making the right and final decision (i.e. is also the tie breaker in case A and team cannot align).',
  },
]

export const rapidMatrixColumns: string[] = [
  'Global CM&CO',
  'Global Category President',
  'OU CMOs *',
  'Global Brand Lead',
  'Global XP Lead rep **',
  'Design & Pckg rep **',
  'Global Insights rep **',
  'Global Category strategy **',
  'R&D (TCR & GDI)',
  'WPP Strategist',
]

export interface RapidMatrixRow {
  label: string
  highlight?: boolean
  cells: RapidLetter[][]
}

export const rapidMatrixRows: RapidMatrixRow[] = [
  {
    label: 'BVA Sign off',
    highlight: true,
    cells: [['D'], ['R'], ['A'], ['I', 'P'], ['I', 'P'], [], ['I', 'P'], ['I'], ['I'], []],
  },
  {
    label: 'People',
    cells: [[], ['D'], ['A'], ['R', 'P'], ['I'], [], ['I', 'P'], ['I'], [], ['I']],
  },
  {
    label: 'Product',
    cells: [[], ['D'], ['A'], ['R', 'P'], ['I'], [], ['I'], ['I', 'P'], ['I', 'P'], ['I']],
  },
  {
    label: 'Brand',
    cells: [[], ['D'], ['A'], ['R', 'P'], ['I', 'P'], ['I', 'P'], ['I'], ['I'], [], ['I']],
  },
  {
    label: 'Meaningful brand role',
    cells: [[], ['D'], ['A'], ['R', 'P'], ['I', 'P'], [], ['I'], ['I'], ['I'], ['I']],
  },
]

export const rapidMatrixFootnotes = [
  { mark: '*', text: 'Via their OU champions' },
  { mark: '**', text: 'Representatives that are responsible for that brand or assigned to the BVA work' },
]

export const kickoffIntro = 'As an early step in the process, it is critical you hold a kickoff with your team.'

export const kickoffParagraphs = [
  'This is a crucial moment to make R&Rs clear, ensure everyone is exposed to the same critical background information, and is aligned on the end goal and how to get there.',
  'Led by the Brand Lead (+PMO if applicable), it can be conducted either as a single session or split into multiple virtual calls. Follow this guide to shape a successful kickoff.',
]

export const kickoffModalIntro =
  'As an early step in the process, it is critical you hold a kickoff with your team. This is a crucial moment to make R&Rs clear, ensure everyone is exposed to the same critical background information, and is aligned on the end goal and how to get there.'

export const kickoffModalFootnote =
  'Led by the Brand Lead (+PMO if applicable), it can be conducted either as a single session or split into multiple virtual calls.'

export interface KickoffItem {
  bold?: string
  text: string
}

export interface KickoffColumn {
  key: 'assemble' | 'context' | 'learnings' | 'guardrails'
  title: string
  headerColor: string
  chipColor: string
  bgColor: string
  time: string
  ledBy: string
  items: KickoffItem[]
}

export const kickoffColumns: KickoffColumn[] = [
  {
    key: 'assemble',
    title: 'ASSEMBLE TEAM',
    headerColor: '#91dda4',
    chipColor: '#91dda4',
    bgColor: 'rgba(196, 241, 207, 0.2)',
    time: '1hr',
    ledBy: 'Led by: BRAND',
    items: [
      { text: 'Core vs Extended team definition' },
      {
        bold: 'KO:',
        text: ' Sponsor, Brand Lead, Extended Categ/Brand team (Insight, Design, XP/ Creative, ca 3 OU Cat/Brand Dir), MPS (Data Analyst), R&D (eg. GDI, TCR)',
      },
      {
        bold: 'Partners (if applicable):',
        text: ' WPP Strategy, Research Partners, Marketing Capabilities Team, Specialized Branding Agency Partners (eg. Motion, Appetite, Tank), Suppliers / Food Science',
      },
    ],
  },
  {
    key: 'context',
    title: 'CONTEXT & BRAND',
    headerColor: '#fedea8',
    chipColor: '#fedea8',
    bgColor: 'rgba(254, 222, 168, 0.2)',
    time: '1-2hr',
    ledBy: 'Led by: BRAND',
    items: [
      { text: 'LRP Ambition & Brand Growth Strategy (incl. Audience Hierarchy)' },
      { text: 'Brand Assessment (why a new BVA & why now) incl. performance metrics' },
      { text: 'Process onboarding (overview of BVA 2.0)' },
      { text: 'Deep dive into lead OUs (based on EP Combos)' },
    ],
  },
  {
    key: 'learnings',
    title: 'LEARNINGS',
    headerColor: '#9fe3e7',
    chipColor: '#9fe3e7',
    bgColor: 'rgba(159, 227, 231, 0.2)',
    time: '30min/1hr',
    ledBy: 'Led by: PMO',
    items: [{ text: 'Testimonial guest to share best practices' }, { text: 'Learning & watchouts' }],
  },
  {
    key: 'guardrails',
    title: 'GUARDRAILS',
    headerColor: '#ff8a7a',
    chipColor: '#ff8a7a',
    bgColor: 'rgba(255, 138, 122, 0.2)',
    time: '2hr',
    ledBy: 'Led by: PMO',
    items: [{ text: 'Definition of Done (what does success look like)' }, { text: 'Backlog' }, { text: 'Role sort' }],
  },
]
